import { render, staticRenderFns } from "./scalepricetooltip.vue?vue&type=template&id=3542047a&"
import script from "./../ts/scalepricetooltip.ts?vue&type=script&lang=js&"
export * from "./../ts/scalepricetooltip.ts?vue&type=script&lang=js&"
import style0 from "./../assets/css/scalepricetooltip.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports